import script from "./EmployeeManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeManagement.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeManagement.vue?vue&type=style&index=0&id=4c0652f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0652f9"]])

export default __exports__